import api from "./http";

const ApiDashboard = {
    getRekapSpp : (kode_lembaga,kelas)=>{
        return api.get(`/cakepin/dashboard?kode_lembaga=${kode_lembaga}&kelas=${kelas}`)
    }
}

export default ApiDashboard